import React, { FunctionComponent } from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { formatDateTime } from 'utils';
import { useCurrentBilikPerson } from 'hooks/use-current-bilik-person/use-current-bilik-person';
import { Review } from '../types/review.type';

type ReviewLockerLabelProps = {
  review: Review;
  size?: 'mini' | 'small';
};

export const ReviewLockerLabel: FunctionComponent<ReviewLockerLabelProps> = ({
  review,
  size = 'small',
}) => {
  const { currentBilikPerson } = useCurrentBilikPerson();

  if (!review.locker) {
    return null;
  }

  const lockerName =
    review.locker.id === currentBilikPerson?.id
      ? 'par vous'
      : `par ${review.locker.givenName} ${review.locker.familyName}`;

  if (size === 'mini') {
    return (
      <Popup
        content={`Avis verrouillé ${lockerName}`}
        trigger={
          <Label color="grey" size="small">
            <Icon fitted name="lock" />
          </Label>
        }
      />
    );
  }

  return (
    <Popup
      content={
        <p style={{ textAlign: 'center' }}>
          Avis verrouillé le :{' '}
          <strong>
            {review.lockDate ? formatDateTime(review.lockDate) : null}
          </strong>
        </p>
      }
      trigger={
        <Label size="small" color="grey">
          <Icon name="lock" />
          Avis verrouillé {lockerName}
        </Label>
      }
    />
  );
};
